import { apolloClient } from "@/plugins/vue-apollo.js";

const toggleAreaStatus= (_variables) => {
  let responseFromApi;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/area/toggle_area_status.graphql"),
      variables: _variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/area/area_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        store.writeQuery({
          ...query,
          data: data,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { toggleAreaStatus };
